import React, { Fragment } from 'react';
import Link from 'react-router-dom/Link';
import { Menu, Dropdown, Icon, Modal, Button, Carousel } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UserPreference from '../UserPreference';
import InputField from '../InputField';
import Epd from '../../Epd';
import PlugwrapThickness from '../../PlugwrapThickness';
import ShareFilterCigarette from '../../../containers/ShareFilterCigarette';
import DeleteObsolete from '../../DeleteObsolete';
import TipVent from '../../TipVent';
import FirmnessTesterConversion from '../../FirmnessTesterConversion';
import Translation from '../../../Translation';
import './header.css';
import routes from '../../../routes';
import CelaneseAPI from '../../../services';
import config from '../../../config';


/**
 * Class for header.
 *
 * @class Header
 * @extends {React.Component}
 */
class Header extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalVisible: false,
            isEpdVisible: false,
            isPlugwrapVisible: false,
            isShareVisible: false,
            openingPlugwrapFromHeader: true,
            isDeleteObsoleteVisible: false,
            isTipVisible: false,
            openingTipVentFromHeader: true,
            isFirmnessTesterVisible: false,
            isLongMessageModalVisible: false,
            selectedLongMessageIndex: 0,
            activePreviewMessageIndex: 0,
            helpPath: '',

            showChangePasswordModal: false,
            currentPassword: '',
            password: '',
            confirmPassword: '',

            currentPasswordErr: null,
            passwordErr: null,
            confirmPasswordErr: null,
            isUpdating: false
        };

        this.bindActiveList = this.bindActiveList.bind(this);
        this.setModalVisible = this.setModalVisible.bind(this);
        this.showEpdScreen = this.showEpdScreen.bind(this);
        this.showPlugwrapScreen = this.showPlugwrapScreen.bind(this);
        this.showShareScreen = this.showShareScreen.bind(this);
        this.showDeleteObsoleteScreen = this.showDeleteObsoleteScreen.bind(this);
        this.showTipVentScreen = this.showTipVentScreen.bind(this);
        this.showFirmnessTesterScreen = this.showFirmnessTesterScreen.bind(this);
        this.previousLocation = this.props.location ? this.props.location.pathname : '';
        this.manageMessagesCarousel = React.createRef();
    }

    /**
     * hideDropdownForOthers function is for hiding the dropdown once the user clicks somewhere else
     * @param {} elem
     * @memberof Header
     */
    hideDropdownForOthers(elem) {
        let elemList = document.querySelectorAll('.active');
        if (elemList.length) {
            elemList.forEach(function (item) {
                if (elem !== item)
                    item.classList.remove('active');
            });
        }
        if (elem)
            elem.classList.add('active');
    }

    /**
     * setModalVisible function is for showing the user preference window
     * @param {*} e here e is an event passed
     * @param {boolean} isModalVisible
     * @memberof Header
     */
    setModalVisible(isModalVisible, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ isModalVisible });
    }

    changePassword(e) {
        if (e) {
            e.preventDefault();
        }
        window.changePassword();
    }

    saveChangePassword(e) {
        this.setState({
            isUpdating: true
        });
        let formData = {
            "password": this.state.password
        };
        CelaneseAPI.post(config.API.changePassword, formData).then((resp) => {
            console.log("resp", resp);
        });
    }

    handleChange = (e) => {
        if (e && e.target) {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    /**
     * showEpdScreen function is for showing the epd bias window
     * @param {*} e here e is an event passed
     * @param {boolean} isEpdVisible
     * @memberof Header
     */
    showEpdScreen(isEpdVisible, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ isEpdVisible });
    }

    /**
     * showPlugwrapScreen function is for showing the plugwrap window
     * @param {*} e here e is an event passed
     * @param {boolean} isPlugwrapVisible
     * @memberof Header
     */
    showPlugwrapScreen(isPlugwrapVisible, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ isPlugwrapVisible });
    }

    /**
     * showShareScreen function is for showing the share filter/cigarette window
     * @param {*} e here e is an event passed
     * @param {boolean} isShareVisible
     * @memberof Header
     */
    showShareScreen(isShareVisible, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ isShareVisible });
    }

    /**
     * handlePlugwrapCancel function is for closing the plugwrap window
     * 
     * @memberof Header
     */
    handlePlugwrapCancel = () => {
        this.setState({ isPlugwrapVisible: false });
    }

    /**
     * showDeleteObsoleteScreen function is for showing the delete obsolete design window
     * @param {*} e here e is an event passed
     * @param {boolean} isDeleteObsoleteVisible
     * @memberof Header
     */
    showDeleteObsoleteScreen(isDeleteObsoleteVisible, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ isDeleteObsoleteVisible });
    }

    /**
     * showTipVentScreen function is for showing the tip vent calculation window
     * @param {*} e here e is an event passed
     * @param {boolean} isTipVisible
     * @memberof Header
     */
    showTipVentScreen(isTipVisible, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ isTipVisible });
    }

    /**
     * showFirmnessTesterScreen function is for showing the firmness tester calculation window
     * @param {*} e here e is an event passed
     * @param {boolean} isFirmnessTesterVisible
     * @memberof Header
     */
    showFirmnessTesterScreen(isFirmnessTesterVisible, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ isFirmnessTesterVisible });
    }

    componentDidMount() {
        document.addEventListener('click', () => {
            this.hideDropdownForOthers(null);
        });
    }

    componentWillUpdate(nextProps) {
        if (nextProps.location && nextProps.location.action !== 'POP') {
            this.previousLocation = nextProps.location.pathname;
        }
    }

    /**
     * bindActiveList function is for inidcating the active link of the header 
     * @param {*} e here e is an event passed
     * @memberof Header
     */
    bindActiveList(e) {
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        let elem = e.target.parentElement;
        if (elem.classList.contains('active')) {
            this.hideDropdownForOthers(null);
        } else {
            this.hideDropdownForOthers(elem);
        }
    }

    /**
     * hidePreview function is for hiding preview content
     * @param {*} e here e is an event passed
     * @memberof Header
     */
    hidePreview = (e) => {
        e && e.preventDefault();
        const quickPreviewWrapper = document.querySelector('.quick-preview-message');
        if (quickPreviewWrapper) {
            const manageMessagesTable = document.querySelector('.cmp-manage-messages__table-wrapper');
            if (manageMessagesTable) {
                manageMessagesTable.style['height'] = (manageMessagesTable.offsetHeight + quickPreviewWrapper.offsetHeight) + 'px';
            }
            quickPreviewWrapper.classList.add('displayNone');
            document.querySelector('.main').style['padding-top'] = document.querySelector('.celanese-header').offsetHeight + 'px';
        }
    }

    /**
     * showLongMessageModal function is for showing long message modal
     * @param {*} e here e is an event passed
     * @memberof Header
     */
    showLongMessageModal = (e, ind) => {
        e.preventDefault();
        this.setState({
            isLongMessageModalVisible: true,
            selectedLongMessageIndex: ind
        });
    }

    /**
     * hideLongMessageModal function is for hiding long message modal
     * @memberof Header
     */
    hideLongMessageModal = () => {
        this.setState({
            isLongMessageModalVisible: false,
            selectedLongMessageIndex: 0
        });
    }

    /**
     * showPreviousMessage function is for showing previous carousel item in preview messages
     * @memberof Header
     */
    showPreviousMessage = () => {
        if (this.manageMessagesCarousel) {
            this.manageMessagesCarousel.prev();
        }
    }

    /**
     * showNextMessage function is for showing next carousel item in preview messages
     * @memberof Header
     */
    showNextMessage = () => {
        if (this.manageMessagesCarousel) {
            this.manageMessagesCarousel.next();
        }
    }

    /**
     * onChangePreviewMessage function is for getting the index of carousel in preview messages
     * @param {number} a
     * @memberof Header
     */
    onChangePreviewMessage = (a) => {
        this.setState({
            activePreviewMessageIndex: a
        });
    }


    render() {
        console.log('this.props.locion.pathname', this.props.location.pathname);
        let profileData = this.props.prefData;
        let azureProfileData = profileData ? profileData.profile.azureProfile : '';
        let isAdmin = azureProfileData['role'] && azureProfileData['role'].toUpperCase() === 'admin'.toUpperCase() ? true : false;
        let that = this;
        let pageLocation = this.previousLocation;
        let messageData = profileData && profileData.messages ? profileData.messages : [];
        const menu3 = (
            <Menu>
                <Menu.Item key="0">
                    <a href="#" onClick={(e) => this.showEpdScreen(true, e)}><Translation labelName="lbl_epd_bias" defaultText="EPD Bias" /></a>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="1">
                    <a href="#" onClick={(e) => this.showPlugwrapScreen(true, e)}><Translation labelName="menu_item_tools_plugwrap_paper" defaultText="Plugwrap Paper" /></a>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="2">
                    <a href="#" onClick={(e) => this.showFirmnessTesterScreen(true, e)}><Translation labelName="title_tools_firmsness_tester" defaultText="Firmness Tester Conversion" /></a>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="3">
                    <a href="#" onClick={(e) => this.showTipVentScreen(true, e)}><Translation labelName="menu_item_tools_calculate_vent_material" defaultText="Calculate %Tip Vent/Vent Material" /></a>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="4">
                    <a href="#" onClick={(e) => this.showShareScreen(true, e)}><Translation labelName="menu_item_tools_epd_share_filter_cigarette" defaultText="Share Filter Cigarette" /></a>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="5">
                    <a href="#" onClick={(e) => this.showDeleteObsoleteScreen(true, e)}><Translation labelName="title_tools_delete_obsolete" defaultText="Delete Obsolete Designs" /></a>
                </Menu.Item>
            </Menu>
        );

        const menu4 = (

            <Menu>
                <Menu.Item key="0">
                    <Link to={'/items-export-import'}><Translation labelName="title_admin_manage_tow_items" defaultText="Manage Tow Items" /></Link>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="1">
                    <Link to={'/manage-companies'}><Translation labelName="title_admin_manage_company" defaultText="Manage Companies" /></Link>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="2">
                    <Link to={'/manage-messages'}><Translation labelName="title_admin_manage_messages" defaultText="Manage Messages" /></Link>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="3">
                    <Link to={'/model-analyzer'}><Translation labelName="title_admin_modal_analyzer" defaultText="Model Analyzer" /></Link>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="4">
                    <Link to={'/translation-labels'}><Translation labelName="title_admin_translation_labels" defaultText="Translation Labels" /></Link>
                </Menu.Item>
                <Menu.Divider />
                <Menu.SubMenu title={
                    <span><Translation labelName="title_admin_user_tools" defaultText="User Tools" /></span>
                }>
                    <Menu.Item key="5">
                        <Link to={'/manage-users'}><Translation labelName="title_admin_manage_users" defaultText="Manage Users" /></Link>
                    </Menu.Item>
                    <Menu.Divider />
                    <Menu.Item key="8">
                        <Link to={'/request-access'}><Translation labelName="title_admin_request-access" defaultText="Access Requests" /></Link>
                    </Menu.Item>
                    <Menu.Divider />
                    <Menu.Item key="6">
                        <Link to={'/manage-sign-ins'}><Translation labelName="title_admin_sign_in_report" defaultText="Sign-in Report" /></Link>
                    </Menu.Item>
                    <Menu.Divider />
                    <Menu.Item key="7">
                        <Link to={'/manage-analytics'}><Translation labelName="title_admin_detailed-signin" defaultText="Detailed Sign-in" /></Link>
                    </Menu.Item>
                </Menu.SubMenu>
            </Menu>
        );

        const menu5 = (
            <Menu>
                <Menu.Item key="0">
                    <a href="#" onClick={(e) => that.setModalVisible(true, e)}><Translation labelName="lbl_my_preference" defaultText="My Preferences" /></a>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="1">
                    <a href="#" onClick={(e) => that.changePassword(e)}><Translation labelName="lbl_change_password" defaultText="Change Password" /></a>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="2">
                    <a href="mailto:towplus.support@celanese.com"><Translation labelName="lbl_contact_celanese" defaultText="Contact Celanese" /></a>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="3">
                    <a href="#" onClick={(e) => {
                        e.preventDefault();
                        window.logout();
                    }}><Translation labelName="lbl_log_out" defaultText="Log Out" /></a>
                </Menu.Item>
            </Menu>
        );
        let preferenceData = this.props.prefData ? this.props.prefData.preference : '';
        let prefObj;
        if (preferenceData) {
            prefObj = {
                'size': preferenceData.size,
                'epd': preferenceData.epd,
                'weight': preferenceData.weight,
                'pz': preferenceData.pz,
                'rodMaker': preferenceData.rodMaker,
                'transportJet': preferenceData.transportJet,
                'towType': preferenceData.towType,
                'kretek': preferenceData.kretek,
                'epdBias': preferenceData.epdBias,
                'firmnessMethod': preferenceData.firmnessMethod,
                'pivmaxlim': preferenceData.pivmaxlim,
                'lowpdlim': preferenceData.lowpdlim
            };
        }
        let adminMenuItem = '';
        if (isAdmin) {
            const isAdminRoute = routes.find(item => (item.isAdmin && (item.path === pageLocation)));
            adminMenuItem = (<li className={isAdminRoute ? 'header-item active-link' : 'header-item'}>
                {(
                    <Dropdown overlay={menu4} trigger={['click']}>
                        <a className="ant-dropdown-link celanese-header__tab" href="#">
                            <Translation labelName="menu_items_admin" defaultText="Admin" /> <Icon type="down" />
                        </a>
                    </Dropdown>
                )}
            </li>);
        }
        return (
            <Fragment>
                <header className="celanese-header">
                    {
                        messageData.length ? (
                            <Fragment>
                                <div className="quick-preview-message">
                                    <div className="quick-preview-message-content">
                                        {
                                            messageData.length > 1 ? (
                                                <Fragment>
                                                    <span className="prev-icon" onClick={() => this.showPreviousMessage()}>
                                                        <Button type="primary">
                                                            <Icon type="left" />
                                                        </Button>
                                                    </span>
                                                    <span className="preview-message-count"> {this.state.activePreviewMessageIndex + 1 + '/' + messageData.length} </span>
                                                    <span className="next-icon" onClick={() => this.showNextMessage()}>
                                                        <Button type="primary">
                                                            <Icon type="right" />
                                                        </Button>
                                                    </span>
                                                </Fragment>
                                            ) : null
                                        }
                                        <div className={messageData.length > 1 ? 'show-preview-message-carousel' : ''}>
                                            <Carousel ref={node => (this.manageMessagesCarousel = node)}
                                                afterChange={(a) => this.onChangePreviewMessage(a)}
                                                dots={false}>
                                                {
                                                    messageData.map((val, ind) => {
                                                        return (
                                                            <span key={ind}>
                                                                {val.subject}
                                                                {
                                                                    val.text && val.text.length ? (
                                                                        <a href="#" id="showLargeDescription" className="quick-preview-message-readmore" onClick={(e) => this.showLongMessageModal(e, ind)}><Translation labelName="link_read_more" defaultText="Read More" /></a>
                                                                    ) : ''
                                                                }
                                                            </span>
                                                        )
                                                    })
                                                }
                                            </Carousel>
                                        </div>
                                        {
                                            messageData[this.state.selectedLongMessageIndex] ? (
                                                <Modal visible={this.state.isLongMessageModalVisible}
                                                    title={<Translation labelName="title_whats_new" defaultText="What's New" />}
                                                    footer={null}
                                                    width={700}
                                                    centered
                                                    onCancel={() => this.hideLongMessageModal()}
                                                    className="long-message__modal"
                                                >
                                                    {messageData[this.state.selectedLongMessageIndex].text}
                                                </Modal>
                                            ) : null
                                        }
                                    </div>
                                    <Button className="quick-preview-message-close" onClick={(e) => this.hidePreview(e)} size="small" shape="circle" icon="close"></Button>
                                </div>
                            </Fragment>
                        ) : (
                            <div className="quick-preview-message displayNone">
                                <div className="quick-preview-message-content"></div>
                                <Button className="quick-preview-message-close" onClick={(e) => this.hidePreview(e)} size="small" shape="circle" icon="close"></Button>
                            </div>
                        )
                    }
                    <div className="celanese-header__wrapper">
                        <div className="celanese-header__left">
                            <div className="image-wrapper">
                                <Link to={'/'}>
                                    <img
                                        src="./images/towplus-white-final.png"
                                        alt="product name towplus"
                                        className="celanese-header__left--product" />

                                </Link>
                            </div>
                        </div>
                        <nav className="celanese-header__middle">
                            <ul className="header-list">
                                <li className={pageLocation === '/towitemselection' || pageLocation === '/' ? 'header-item active-link' : 'header-item'}><Link to={'/towitemselection'} className="celanese-header__tab"><Translation labelName="menu_tow_item_selection" defaultText="Tow Item Selection" /></Link></li>
                                <li className={pageLocation === '/filter-cigarette-design' ? 'header-item active-link' : 'header-item'}>
                                    <Link to={'/filter-cigarette-design'} className="celanese-header__tab"><Translation labelName="menu_filter_and_cigarette_design" defaultText="Filter &amp; Cigarette Design" /></Link>
                                </li>
                                {/* heat not burn link added  */}
                                <li className={pageLocation === '/Heatnotburn' ? 'header-item active-link' : 'header-item'}><Link to={'/Heatnotburn'} className="celanese-header__tab"><Translation labelName="Heatnotburn" defaultText="HNB/HTP" /></Link></li>

                                <li className="header-item">
                                    <Dropdown overlay={menu3} trigger={['click']}>
                                        <a className="ant-dropdown-link celanese-header__tab" href="#">
                                            <Translation labelName="menu_items_tools" defaultText="Tools" /> <Icon type="down" />
                                        </a>
                                    </Dropdown>
                                </li>
                                {adminMenuItem}
                                {/* <li className='header-item'><a href="/help/TowPlus3.htm" className='celanese-header__tab' target="_blank" title="Help"><Translation labelName="menu_help" defaultText="Help" /></a></li> */}
                            </ul>
                        </nav>
                        <div className="celanese-header__right">
                            <div className="user-section">
                                <Dropdown overlay={menu5} trigger={['click']}>
                                    <a href="#" onClick={this.bindActiveList} className="user-section-link userName">
                                        {profileData && azureProfileData ? azureProfileData.firstName + ' ' + azureProfileData.lastName : null} <Icon type="down" />
                                    </a>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </header>
                <UserPreference prefObj={prefObj} setModalVisible={this.setModalVisible} isModalVisible={this.state.isModalVisible} />
                <Epd
                    isEpdVisible={this.state.isEpdVisible}
                    showEpdScreen={this.showEpdScreen}>
                </Epd>
                {this.state.showChangePasswordModal && (
                    <Modal visible={this.state.showChangePasswordModal}
                        title={<Translation labelName="title_change_password" defaultText="Change Password" />}
                        width='600px'
                        className='change-pwd-modal'
                        centered
                        cancelText={<Translation labelName="btn_cancel" defaultText="Cancel" />}
                        okText={<Translation labelName="btn_save" defaultText="Change Password" />}
                        onOk={(e) => this.saveChangePassword(e)}
                        onCancel={(e) => this.setState({ showChangePasswordModal: false })}>
                        <div>
                            {/* <div className="row">
                                <div className="col-sm-6">
                                    <InputField
                                        type='Password'
                                        label={<Fragment><Translation labelName="lbl_current_password" defaultText="Current Password "/>*</Fragment>}
                                        name='currentPassword'
                                        id='currentPassword'
                                        value={this.state.currentPassword}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-sm-6">
                                    <InputField
                                        type='Password'
                                        label={<Fragment><Translation labelName="lbl_new_password" defaultText="New Password " />*</Fragment>}
                                        name='password'
                                        id='password'
                                        value={this.state.password}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <InputField
                                        type='Password'
                                        label={<Fragment><Translation labelName="lbl_cfm_new_password" defaultText="Confirm New Password " />*</Fragment>}
                                        name='confirmPassword'
                                        id='confirmPassword'
                                        value={this.state.confirmPassword}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            {
                                this.state.isUpdating && <div className="loading-indicator">
                                    <h2 className="loading-indicator-text">
                                        {/* <Icon type="loading" theme="outlined" /> */}
                                        <img alt='loading celanese' src="./images/Celanese_loading.svg" />
                                        <span>Loading</span></h2>
                                </div>
                            }
                        </div>
                    </Modal>
                )}
                {this.state.isPlugwrapVisible && <Modal
                    visible={this.state.isPlugwrapVisible}
                    footer={null}
                    width='80%'
                    centered
                    style={{ top: 20 }}
                    onCancel={this.handlePlugwrapCancel}>
                    <PlugwrapThickness
                        openingPlugwrapFromHeader={this.state.openingPlugwrapFromHeader}
                        updatePlugwrapValue={this.updatePlugwrapValue}
                        handlePlugwrapCancel={this.handlePlugwrapCancel}
                        rowSelectionDisable={true}>
                    </PlugwrapThickness>
                </Modal>}
                {this.state.isDeleteObsoleteVisible &&
                    <DeleteObsolete
                        isDeleteObsoleteVisible={this.state.isDeleteObsoleteVisible}
                        showDeleteObsoleteScreen={this.showDeleteObsoleteScreen}>
                    </DeleteObsolete>}
                {this.state.isTipVisible &&
                    <TipVent
                        isTipVisible={this.state.isTipVisible}
                        showTipVentScreen={this.showTipVentScreen}
                        openingTipVentFromHeader={this.state.openingTipVentFromHeader}>
                    </TipVent>}
                {this.state.isShareVisible &&
                    <ShareFilterCigarette
                        isShareVisible={this.state.isShareVisible}
                        showShareScreen={this.showShareScreen}>
                    </ShareFilterCigarette>}
                {this.state.isFirmnessTesterVisible &&
                    <FirmnessTesterConversion
                        isFirmnessTesterVisible={this.state.isFirmnessTesterVisible}
                        showFirmnessTesterScreen={this.showFirmnessTesterScreen}>
                    </FirmnessTesterConversion>}
            </Fragment>
        );
    }
}

const mapStateToProps = ({ loggedUserState }) => ({
    prefData: loggedUserState.prefData
});

export default connect(mapStateToProps, null)(Header);

Header.propTypes = {
    prefData: PropTypes.object,
    location: PropTypes.object
};


// WEBPACK FOOTER //
// ./src/components/global/Header/index.js